import React from 'react'
import classNames from 'classnames'
import { Card, Badge } from 'react-bootstrap'
import { parseISO, compareDesc, differenceInCalendarDays } from 'date-fns'
import { countDisplay, formatCurrency } from '@utils/strings'

interface BookingCartItemProps {
  booking: any
  firstBooking: boolean
}

const BookingCartItem: React.FC<BookingCartItemProps> = ({ booking, firstBooking }) => {
  const checkIn = parseISO(booking.start_at)
  const checkOut = parseISO(booking.end_at)
  const night_count =
    compareDesc(checkIn, checkOut) > 0 ? differenceInCalendarDays(checkOut, checkIn) : 0

  return (
    <React.Fragment key={`booking-summary-${booking.id}`}>
      <Card className={classNames({ 'mt-3': !firstBooking })} key={`booking-summary-${booking.id}`}>
        <Card.Header className="d-flex justify-content-between align-items-center p-2">
          <div>
            <p className="h5 mb-0">
              {booking.site_name} &bull; {booking.loop_name}
            </p>
            <p className="font-size-sm mb-0">{booking.section_name}</p>
          </div>
          <div>
            <p className="h5 mb-0">${formatCurrency(booking.bookingItem.subtotal)}</p>
          </div>
        </Card.Header>
        <Card.Body className="p-2">
          <p className="mb-0">
            {countDisplay('Guest', booking.occupant_count)},&nbsp;
            {countDisplay('Vehicle', booking.vehicle_count)},&nbsp;
            {countDisplay('Night', night_count)}
          </p>
        </Card.Body>
      </Card>
      {booking.consumableItems.map((item, idx) => (
        <Badge className="bg-gray-100 w-100 mt-2" key={`consumable-${booking.id}-${idx}`}>
          <div className="px-2 py-1 d-flex justify-content-between align-items-center">
            <div>
              <span className="font-weight-medium">
                {item.name} x {item.quantity}
              </span>
            </div>
            <p className="h5 mb-0">${formatCurrency(item.subtotal_with_quantity)}</p>
          </div>
        </Badge>
      ))}
    </React.Fragment>
  )
}

export default BookingCartItem
